var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-store"},[_c('Badge',{attrs:{"dot":"","count":_vm.countComputed}},[_c('Button',{attrs:{"type":"text"},on:{"click":_vm.openErrorLoggerPage}},[_c('Icon',{attrs:{"size":20,"type":"ios-bug-outline"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4f35120","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/components/error-store/error-store.vue
// module id = zJUl
// module chunks = 64